import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { executionLogStateSelector } from "./executionLogStateSelector";

export const executionLogDataSelector = createDraftSafeSelector(
  [executionLogStateSelector],
  (executionLogState) => {
    return executionLogState.data;
  },
);
